import { Box, Typography } from "@mui/material";
import React from "react";
import nojobicon from "../assets/no_job.png";
const NodataFoundCard = ({ maxHeight, action, actionText }) => {
  return (
    <Box
      sx={{
        width: "100%",
        maxHeight,
        minHeight: "13rem",
        margin: "auto",
        bgcolor: "background.paper",
        borderRadius: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mb: 2,
        p: 4,

        position: "relative",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          textAlign: "center",
        }}
      >
        <Box
          component={"img"}
          src={
            "https://projects.tangiblethemes.com/Shglocums/wp-content/uploads/2025/07/no_job.png"
          }
          sx={{ maxWidth: "478px" }}
          alt="not found "
        />
        <Typography
          sx={{
            fontSize: "48px",
            fontWeight: 400,
            color: "text.primary",
            lineHeight: 1.4,
            // maxWidth: "400px",
            fontFamily: "DM Serif Text",
          }}
        >
          You will find a new job here <br /> once it's posted
        </Typography>
      </Box>
    </Box>
  );
};

export default NodataFoundCard;
